export type KeywordRoute = {
  category: string;
  subCategory: string;
};

export type SitemapEntry = {
  keyword: string;
  category: string;
  subCategory: string;
};

/**
 * Resolves a keyword to its (category, subCategory) pair by looking it up in
 * the provided sitemap entries.
 *
 * Returns null if the keyword is not found.
 */
export function getKeywordRoute(
  keyword: string,
  entries: SitemapEntry[],
): KeywordRoute | null {
  const entry = entries.find((e) => e.keyword === keyword);
  if (!entry) return null;

  return { category: entry.category, subCategory: entry.subCategory };
}
